module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"documents":"Documents","noDocuments":"There are no documents yet.","open":"Open","documentType":"Type","description":"Description","alternateDescription":"Alternate Description"},"no":{"documents":"Dokumenter","noDocuments":"Det er ingen dokumenter ennå.","open":"Åpne","documentType":"Type","description":"Beskrivelse","alternateDescription":"Alternativ Beskrivelse"}}')
  delete Component.options._Ctor
}
